import React, { useEffect, useState } from 'react';
import "./Category.css";

import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
// import { GetFeedbackPage, Getblinkit } from '../apiconfig/authService';
import { Pagination } from "rsuite";
import 'rsuite/dist/rsuite.min.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getallPincode } from "../apiconfig/authService";
function Swiggy(props) {
    const navigate = useNavigate();
    const { isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');
    const today = new Date();
    const message = props.message;
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    // const [categoriesData, setCategoriesData] = useState([]);
    const [swiggyData, setSwiggyData] = useState([]);
    const [totalFeedbacks, setTotalFeedbacks] = useState();
    const [pincode, setPincode] = useState([]);

    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    // const [totalCategories, setTotalCategories] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    // const [recordIdToDelete, setRecordIdToDelete] = useState('');
    const [refetchData, setRefetchData] = useState(false);
    const [selectedRows, setSelectedRows] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [Selectpincode, setSelectpincode] = useState("122001");
    const [loadingRows, setLoadingRows] = useState({});
    const [pincodeList, setPincodeList] = useState([]);
    const handlePerPageRecordsChange = (e) => {
        setItemsPerPage(e.target.value);
        setPageCount(1);
    };
    console.log("swiggyData?????????????????", swiggyData)
    const formatUTCDate = (utcDateString) => {
        if (!utcDateString) return null;

        const date = new Date(utcDateString);
        if (isNaN(date.getTime())) return null; // Handle invalid date

        // Convert UTC date to local date (YYYY-MM-DD format)
        return date.toLocaleDateString("en-CA"); // "YYYY-MM-DD"
    };

    useEffect(() => {
        const fetchPincode = async () => {
            try {
                const response = await getallPincode(pincode, localStorage.getItem("accessToken"))
                const data = response.data.pincodes
                console.log("data??????????", data)
                const activePincodes = data.filter(item => item.isactive === 1);
                setPincodeList(activePincodes)
                console.log("activePincodes??????", activePincodes)
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchPincode()
    }, [])

    useEffect(() => {
        (
            async () => {
                try {
                    const queryParams = {
                        pincode: Selectpincode,
                        page,
                        itemsPerPage,
                        search,
                        startDate: startDate ? startDate.toISOString().split('T')[0] : null,
                        endDate: endDate ? endDate.toISOString().split('T')[0] : null,
                    };

                    // const feedbacksData = await Getblinkit(queryParams, localStorage.getItem('accessToken'));
                    const swiggyData = await axios.get(
                        "https://scrapbackend.pikeazy.in/store/getswiggy",
                        { params: queryParams }
                    );

                    setSwiggyData(swiggyData.data.items);
                    console.log("eedbacksData.data.items??????", swiggyData.data.items)
                    console.log("eedbacksData.data.items??????", swiggyData.data.items)
                    setPincode(swiggyData.data.items.pincodeinfo)
                    setPageCount(Math.ceil(swiggyData.data.pagination.pageCount));
                    setTotalFeedbacks(swiggyData.data.pagination.count);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, [page, itemsPerPage, refetchData, Selectpincode]);

    const handleSearchBoxSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setRefetchData(!refetchData)
    };
    const handleSelectAll = () => {
        const allSelected = !selectAll; // Toggle the selectAll state
        setSelectAll(allSelected);

        const updatedSelectedRows = {};
        const updatedSelectedData = {};

        if (allSelected) {
            // Select all rows and ensure weights are processed
            swiggyData.forEach((item) => {
                const weight = item.pincodeinfo.map((pincodeItem) => pincodeItem.weight)[0] || "weight"; // Get the first weight

                updatedSelectedRows[item._id] = true;
                updatedSelectedData[item._id] = {
                    productId: item.productid,
                    swiggyinstamartid: item.swiggyinstamartid,
                    swiggyweight: weight
                };
            });
        }

        setSelectedRows(updatedSelectedRows);
        setSelectedData(updatedSelectedData);

        console.log("All rows selected:", updatedSelectedData);
    };

    const handleRowSelect = (id, productId, swiggyinstamartid, swiggyweight) => {
        const updatedSelectedRows = { ...selectedRows, [id]: !selectedRows[id] };

        console.log("swiggyweight///", swiggyweight)
        // Extract the first weight if swiggyweight is an array
        const weight = swiggyweight && swiggyweight.weight && Array.isArray(swiggyweight.weight) && swiggyweight.weight.length > 0
            ? swiggyweight.weight[0] // Use the first value
            : swiggyweight || ""; // Fallback if undefined
        console.log("swiggyweight?????", weight)
        console.log("updatedSelectedRowswiggy", updatedSelectedRows, weight);

        // Update the selected data with the correct structure
        const updatedSelectedData = { ...selectedData };
        if (updatedSelectedRows[id]) {
            updatedSelectedData[id] = {
                productId,
                swiggyinstamartid,
                swiggyweight: weight // Use the processed weight string
            };
        } else {
            delete updatedSelectedData[id];
        }

        setSelectedRows(updatedSelectedRows);
        setSelectedData(updatedSelectedData);

        console.log("Selected data (product):", updatedSelectedData);
    };

    const handleUpload = async () => {
        const selectedEntries = Object.values(selectedData);

        if (selectedEntries.length === 0) {
            toast.warning("Please select at least one row before uploading.", {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
            return;
        }

        console.log("Selected Entries:", selectedEntries);

        // Mark all selected rows as loading
        const loadingState = {};
        Object.keys(selectedData).forEach((id) => {
            loadingState[id] = true;
        });
        setLoadingRows(loadingState);

        const pincode = Selectpincode; // Replace with the desired pincode
        const payload = {
            products: selectedEntries.map((entry) => ({
                productId: entry.productId,
                swiggyinstamartid: entry.swiggyinstamartid,
                swiggyweight: entry.swiggyweight,
            })),
        };

        console.log("Payload to be sent:", payload);

        try {
            const response = await fetch(
                `https://scrapbackend.pikeazy.in/manual/getProductsSwiggyManual?pincode=${pincode}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const data = await response.json();
            toast.success("Manual scrapping initiated successfully!", {
                position: "top-right",
                autoClose: 1000,
            });
            // Second API call (after the first one succeeds)
            const secondPayload = {
                productInfo: Object.values(selectedData).map(entry => ({
                    store: "swiggy",
                    productid: entry.swiggyinstamartid, // e.g. "491377382" or "603826945"
                })),
            };
            const secondResponse = await fetch(
                `https://scrapbackend.pikeazy.in/product/productPriceRangeManual?pincode=${pincode}`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(secondPayload),
                }
            );

            const secondData = await secondResponse.json();
            console.log("Second API Response:", secondData);
            // toast.success("Manual scrapping initiated successfully!", {
            //     position: "top-right",
            //     autoClose: 1000,
            // });
            // Optionally update state with the API response here
            console.log("API Response:", data);
        } catch (error) {
            console.error("Error during manual scrapping:", error);
            toast.error("Failed to initiate manual scrapping!", {
                position: "top-right",
                autoClose: 1000,
            });
        } finally {
            // Remove the loading indicator for all selected rows
            const loadingReset = {};
            Object.keys(selectedData).forEach((id) => {
                loadingReset[id] = false;
            });
            setLoadingRows(loadingReset);
        }
    };

    const isCurrentDate = (date) => {
        if (!date) return false; // Handle null/undefined cases
        console.log("c?", date);

        const formattedToday = formatUTCDate(new Date()); // Format today's date in local time
        const formattedItemDate = formatUTCDate(date); // Convert input date to local format

        if (!formattedItemDate) return false; // Handle invalid date

        // console.log(`Checking date: ${formattedItemDate} against ${formattedToday}`);

        return formattedItemDate === formattedToday;
    };
    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={"de"} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={"menu"} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Swiggy Management<br /><small className="text-primary h6 fw-bold">Total counts {totalFeedbacks}</small></h1>
                    <div className="d-inline-flex gap-2">
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleUpload}
                        >
                            Manual Scrapping
                        </button>
                    </div>
                </div>
                <div className="collapse mb-4" id="filter">
                    <div className="card card-body">
                        <form className="filterForm" action="/">
                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatBilling" aria-label="Billing">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatBilling">Billing</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatStatus" aria-label="Status">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatStatus">Status</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="searchList row g-3 align-items-end">
                    {/* Display Records Section */}
                    <div className="col-lg-2 col-md-3 col-sm-4">
                        <label className="form-label">Display Records</label>
                        <select
                            className="form-select"
                            value={itemsPerPage}
                            onChange={handlePerPageRecordsChange}
                        >
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="75">75</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>

                    {/* Pincode Dropdown */}

                    <div className="col-lg-2 col-md-3 col-sm-4 h-50">
                        <label className="form-label">Select Pincode</label>
                        <select
                            className="form-select"
                            value={Selectpincode}
                            onChange={(e) => setSelectpincode(e.target.value)}
                        >
                            <option value="122001">122001</option>
                            <option value="122002">122002</option>
                        </select>
                    </div>

                    {/* Date Filters */}
                    <div className="col-lg-4 col-md-6 col-sm-8">
                        <form onSubmit={handleSearchBoxSubmit}>
                            <div className="row">
                                <div className="col">
                                    <label className="form-label">Start Date</label>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        className="form-control"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select start"
                                    />
                                </div>
                                <div className="col">
                                    <label className="form-label">End Date</label>
                                    <DatePicker
                                        selected={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        className="form-control"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Select end"
                                    />
                                </div>
                                <div className="col-auto d-flex align-items-end">
                                    <button type="submit" className="btn btn-primary">
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>

                    {/* Search Box */}
                    <div className="col-lg-2 col-md-3 col-sm-4 text-end">
                        <form className="sForm w-100" onSubmit={handleSearchBoxSubmit}>
                            <input
                                type="text"
                                onChange={(event) => setSearch(event.target.value)}
                                className="form-control"
                                placeholder="Search"
                                style={{ height: '38px' }}  // Adjust height to match DatePicker
                            />
                        </form>
                    </div>
                </div>

                {message && <div className="alert alert-primary" role="alert">{message}</div>}
                <div className="table-responsive">
                    <table className="table table-borderless table-hover my-3">
                        <thead>
                            <tr>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '50px' }} scope="col" width="45" align="center">
                                    <div className="selectAll">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={handleSelectAll}
                                            aria-label="Select all rows"
                                        />
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col" width="80">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">SR.</span>
                                        <button className="filtBtn idFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Productid</span>
                                        <button className="filtBtn fNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Product name</span>
                                        <button className="filtBtn fNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">swiggyid</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">weight</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '100px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Code</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '120px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Message</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Pincode</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">swiggyPrice</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '200px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">swiggyQuantity</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Availiblity
                                        </span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">IsScrape</span>
                                        <button className="filtBtn lNameFilter"></button>
                                    </div>
                                </th>

                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '170px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Created Date</span>
                                        <button className="filtBtn statusFilter"></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '170px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Modified Date</span>
                                        <button className="filtBtn emailFilter"></button>
                                    </div>
                                </th>
                                <th
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        minWidth: "150px",
                                    }}
                                    scope="col"
                                >
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Scrape</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {swiggyData.map((item, index) => {
                                console.log(`Item ID: ${item?.productid}, Created Date:`, item?.createddate); // Log the createddate

                                return (
                                    <tr key={item?._id}>
                                        <td>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={!!selectedRows[item?._id]}
                                                onChange={() =>
                                                    handleRowSelect(item?._id, item?.productid, item?.swiggyinstamartid,
                                                        {
                                                            weight: item?.pincodeinfo.map((pincodeItem) => pincodeItem?.weight)
                                                        }
                                                    )
                                                }
                                                aria-label={`Select row for product ${item?.productid}`}
                                            />
                                        </td>
                                        <td>{index + 1}</td>
                                        <td>{item?.productid}</td>
                                        <td>{item?.productname}</td>
                                        <td>{item?.swiggyinstamartid}</td>
                                        {/* Loop over pincodeinfo to match the structure of BigBasket */}
                                        {item.pincodeinfo.map((pincodeItem, pIndex) => (
                                            <React.Fragment key={pIndex}>
                                                <td>{pincodeItem?.weight}</td>
                                                <td>{pincodeItem?.code}</td>
                                                <td>{pincodeItem?.message}</td>
                                                <td>{pincodeItem?.pincode}</td>
                                                <td>{pincodeItem?.swiggyprice}</td>
                                                <td>{pincodeItem?.swiggyquantity}</td>
                                                <td>{pincodeItem?.availiblity}</td>
                                                <td>{pincodeItem?.isScrape ? "Yes" : "No"}</td>
                                            </React.Fragment>
                                        ))}
                                        <td>{formatUTCDate(item?.createddate)}</td>
                                        <td>{formatUTCDate(item?.modifieddate)}</td>
                                        <td>
                                            {/* Show button only if the record is from today */}
                                            {isCurrentDate(item?.createddate) ? (
                                                // <button
                                                //     type="button"
                                                //     className="btn btn-sm btn-primary"
                                                //     onClick={() => handleUpload(item.productid, item.swiggyinstamartid)}
                                                // >
                                                //     Manual
                                                // </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => handleUpload(item?._id, item?.productid, item?.swiggyinstamartid)}
                                                    disabled={loadingRows[item._id]}  // disable button while loading
                                                >
                                                    {loadingRows[item?._id] ? (
                                                        // Spinner for visual feedback (using Bootstrap spinner)
                                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    ) : (
                                                        "Manual"
                                                    )}
                                                </button>
                                            ) : null}
                                        </td>
                                    </tr>
                                );
                            })}

                        </tbody>
                    </table>
                </div>
                <div className="resultList pt-3 border-top">
                    <div className="row">
                        <div className="d-flex justify-content-between displayRecord col mt-2">
                            {totalFeedbacks === 0 ? (
                                <div style={{ margin: "auto" }}>No Data found.</div>
                            ) : (
                                <div>
                                    Showing {(page - 1) * itemsPerPage + 1} -{" "}
                                    {totalFeedbacks < itemsPerPage * page
                                        ? totalFeedbacks
                                        : itemsPerPage * page}{" "}
                                    of {totalFeedbacks} entries.
                                </div>
                            )}
                            {/* Render pagination only if totalFeedbacks is greater than 0 */}
                            {totalFeedbacks > 0 && (
                                <div>
                                    <Pagination
                                        prev
                                        last
                                        next
                                        first
                                        size="sm"
                                        ellipsis
                                        boundaryLinks
                                        onSelect={setPage}
                                        limit={itemsPerPage}
                                        onChangeLimit={setItemsPerPage}
                                        layout={["pager", "skip"]}
                                        pages={pageCount}
                                        total={totalFeedbacks}
                                        maxButtons={5}
                                        activePage={page}
                                        onChangePage={(page) => {
                                            setPage(page);
                                        }}
                                    />
                                </div>
                            )}
                            {/* Pagination End */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}
export default Swiggy;
